import { dataTestId } from 'modules/experiments/constants';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { useVariantConfigurationContext } from 'modules/experiments/contexts';
import { PrimaryButton } from 'ui/button';
import { Save } from 'ui/icons';
import { VariantCardFooterWrapper } from './Styled';

export const STOCardAction = () => {
  const { t } = useExperimentsTranslations();
  const { toggleToPreviewSelectMode } = useVariantConfigurationContext();

  return (
    <VariantCardFooterWrapper data-test={dataTestId.variantCardFooterSTO}>
      <PrimaryButton onClick={toggleToPreviewSelectMode}>
        <Save height={16} width={16} /> {t('button.save')}
      </PrimaryButton>
    </VariantCardFooterWrapper>
  );
};
